import { render, staticRenderFns } from "./InputFileBase.vue?vue&type=template&id=a875fc7e&"
import script from "./InputFileBase.vue?vue&type=script&lang=js&"
export * from "./InputFileBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports